var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 41 40" } },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "#F2F2F7",
          "fill-rule": "evenodd",
          d:
            "M10.256 0h20.493c3.398 0 4.633.357 5.872 1.02A6.894 6.894 0 0 1 39.48 3.9c.666 1.244 1.019 2.473 1.019 5.87v20.483c0 3.397-.353 4.63-1.02 5.874a6.946 6.946 0 0 1-2.86 2.858C35.382 39.648 34.148 40 30.75 40H10.256c-3.398 0-4.633-.353-5.876-1.015a6.96 6.96 0 0 1-2.86-2.858C.853 34.884.5 33.65.5 30.254V9.77c0-3.396.353-4.625 1.02-5.869A6.91 6.91 0 0 1 4.38 1.02C5.633.357 6.858 0 10.256 0z",
          "clip-rule": "evenodd"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#4868FD",
          "fill-rule": "evenodd",
          d:
            "M11.43 27.327h18.136a2.918 2.918 0 0 0 2.934-2.902v-9.527A2.918 2.918 0 0 0 29.566 12H11.43a2.916 2.916 0 0 0-2.93 2.898v9.527a2.914 2.914 0 0 0 2.93 2.902z",
          "clip-rule": "evenodd"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#02016F",
          "fill-rule": "evenodd",
          d: "M8.5 18.192h24v-2.643h-24v2.643z",
          "clip-rule": "evenodd"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }